<template>
  <div class="router-tab">
    <component :is="tabComponent" :val="routeFullPath" :label="label" :current-tab="currentTab">
      <slot />
    </component>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, PropType } from "vue";
import { RouteLocationRaw, useRouter } from "vue-router";
import { Tab } from "tir-components";
import RouterTabButton from "./router-tab-button.vue";

const router = useRouter();

const props = defineProps({
  route: {
    type: Object as PropType<RouteLocationRaw>,
    required: true,
  },
  label: {
    default: null,
    type: String as PropType<string | null>,
  },
  currentTab: {
    default: null,
    type: String,
  },
});

const isButton = inject("routerTabsIsButton", false);

const tabComponent = computed(() => (isButton ? RouterTabButton : Tab));

const routeFullPath = computed(() => router.resolve(props.route).fullPath);
</script>

<style lang="scss" scoped></style>
